const authProvider = {
    login: async ({ username, password }) => {
        if (!username || !password) {
            throw new Error('Username and password cannot be empty');
        }

        const request = new Request('https://password-manager-api.dimchang.workers.dev/api/user', {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        try {
            const response = await fetch(request);
            if (response.status < 200 || response.status >= 300) {
                throw new Error(response.statusText);
            }
            const auth = await response.json();
             if (auth.message === 'Login successfully') { // API 返回 "Password added successfully" 表示验证成功
                localStorage.setItem('auth', JSON.stringify(auth)); // 可以选择保存 auth 信息
                return Promise.resolve();
            } else {
                throw new Error('Login failed'); // 显式抛出错误
            }
        } catch (e) {
            throw new Error('Login failed. Invalid username or password.');
        }
    },
    logout: async () => {
        localStorage.removeItem('auth');
        return Promise.resolve();
    },
    checkAuth: async () => {
        return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject();
    },
    checkError: async (error) => {
        if (error.status === 401 || error.status === 403) {
            localStorage.removeItem('auth');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    getPermissions: async () => {
        return Promise.resolve();
    },
    getUserIdentity: async () => {
        try {
            const auth = JSON.parse(localStorage.getItem('auth'));
            return Promise.resolve({
                id: auth.id, //  假设 API 返回的 auth 包含 username
                fullName: auth.username,
                avatar: '',
            });
        } catch (error) {
            return Promise.reject(error);
        }
    },
};

export default authProvider;
